<template>
    <v-card flat>
        <v-overlay :value="loadingExportInvoiceData">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-toolbar color="bal-gray" dense>
            <v-toolbar-title
                >{{ $route.params.exportInvoiceId === "new" ? "Add new" : activeExportInvoice.id }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="bal-red" dark @click="submitEdit">
                <v-icon>done</v-icon>
                {{ "Save" | t }}
            </v-btn>
            <v-btn icon @click="closeDrawer()">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab style="text-transform: none !important;">
                {{ "General info" | t }}
            </v-tab>
            <v-tab-item>
                <general-info-edit-tab />
            </v-tab-item>
            <v-tab style="text-transform: none !important;">
                {{ "Transport" | t }}
            </v-tab>
            <v-tab-item>
                <transport-edit-tab />
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Store from "../../store";
import GeneralInfoEditTab from "../export-sale-invoice/export-sale-invoice-tab-items/general-info-edit-tab";
import TransportEditTab from "../export-sale-invoice/export-sale-invoice-tab-items/transport-edit-tab";

export default {
    name: "export-sale-invoice-edit",
    components: {
        GeneralInfoEditTab,
        TransportEditTab
    },
    data() {
        return {
            tab: 0,
            tabs: ["General info", "Transport"],
            datepickerDate: new Date()
        };
    },
    async beforeMount() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        if (this.$route.params.exportInvoiceId === "new") {
            await Store.commit("ExportSaleInvoiceStore/addActiveExportInvoice");
        } else {
            await Store.dispatch("ExportSaleInvoiceStore/getExportInvoiceData", this.$route.params.exportInvoiceId);
        }
        if (this.$route.params.tab) {
            this.tab = this.tabs.indexOf(this.$route.params.tab);
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    methods: {
        async submitEdit() {
            await Store.dispatch("ExportSaleInvoiceStore/sendExportInvoice", this.activeExportInvoice);
            await this.$router.push({ name: "export-sale-invoice-list" });
        },
        updateField(value, field) {
            Store.commit("ExportSaleInvoiceStore/updateActiveExportInvoiceProperty", { prop: field, value: value });
        },
        closeDrawer() {
            this.$router.push({ name: "export-sale-invoice-list" });
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 83 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.submitEdit();
            }
            /*if (
                document.activeElement.tagName !== "INPUT" &&
                document.activeElement.tagName !== "TEXTAREA" &&
                document.activeElement !== document.querySelector(".ProseMirror-focused") //tipTap editor
            ) {
                if (e.key === "ArrowLeft") {
                    if (this.tab > 0) {
                        this.tab -= 1;
                    }
                } else if (e.key === "ArrowRight") {
                    if (this.tab + 1 < this.tabs.length) {
                        this.tab += 1;
                    }
                }
            }*/
        }
    },
    computed: {
        ...mapState("ExportSaleInvoiceStore", ["activeExportInvoice", "loadingExportInvoiceData"])
    }
};
</script>

<style scoped>
.t-divider {
    border-color: darkgrey !important;
}
</style>
